import { Component, OnInit } from '@angular/core'
import { RepositoryModal, BusinessPlanSection } from '../../shared'
import { FormsModule } from '@angular/forms'
import { QuillEditorComponent } from 'ngx-quill'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'

@Component({
    templateUrl: './business-plan-section.component.html',
    standalone: true,
    imports: [FormsModule, QuillEditorComponent, FaIconComponent],
})
export class BusinessPlanSectionComponent extends RepositoryModal<BusinessPlanSection> implements OnInit {
    editorModules = {
        toolbar: {
            container: [
                ['bold', 'italic', 'underline'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                [{ header: [1, 2, 3, false] }],
                ['link'],
            ],
        },
        clipboard: {
            matchVisual: false,
        },
    }

    ngOnInit() {
        if (this.isAdding) {
            // Set default values for new business plan section
            this.target.order = 1
            this.target.sectionType = 1
        }
    }
}
